const ApplePay = ({ ...props }) => {
  return (
    <svg
      width="38"
      height="24"
      viewBox="0 0 38 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6206_121272)">
        <path
          opacity="0.07"
          d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z"
          fill="black"
        />
        <path
          d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z"
          fill="white"
        />
        <g clipPath="url(#clip1_6206_121272)">
          <path
            d="M10.119 8.41817C9.79084 8.78972 9.26584 9.08278 8.74084 9.04091C8.67521 8.53853 8.93224 8.00476 9.23302 7.67507C9.56115 7.29305 10.1354 7.02093 10.6002 7C10.6549 7.52331 10.4416 8.03616 10.119 8.41817ZM10.5947 9.14034C9.83459 9.09848 9.1838 9.55376 8.82287 9.55376C8.45646 9.55376 7.90412 9.16127 7.30255 9.17174C6.52052 9.18221 5.79318 9.60609 5.39396 10.2812C4.57365 11.6313 5.18068 13.6304 5.97365 14.7293C6.36193 15.2735 6.82677 15.8701 7.43927 15.8492C8.01896 15.8283 8.24865 15.4881 8.94865 15.4881C9.65412 15.4881 9.85646 15.8492 10.469 15.8387C11.1033 15.8283 11.5026 15.2945 11.8908 14.7502C12.3338 14.1327 12.5143 13.5309 12.5252 13.4995C12.5143 13.4891 11.3002 13.0442 11.2893 11.7046C11.2783 10.5847 12.2463 10.0509 12.2901 10.0195C11.7432 9.245 10.8901 9.16127 10.5947 9.14034ZM14.9861 7.62274V15.7812H16.3096V12.9919H18.1416C19.8151 12.9919 20.9908 11.893 20.9908 10.3021C20.9908 8.71123 19.8369 7.62274 18.1854 7.62274H14.9861ZM16.3096 8.69029H17.8354C18.9838 8.69029 19.6401 9.2764 19.6401 10.3073C19.6401 11.3382 18.9838 11.9296 17.8299 11.9296H16.3096V8.69029ZM23.408 15.844C24.2393 15.844 25.0104 15.441 25.3604 14.8026H25.3877V15.7812H26.6127V11.7203C26.6127 10.5428 25.6283 9.78402 24.1135 9.78402C22.708 9.78402 21.669 10.5533 21.6307 11.6104H22.8229C22.9213 11.108 23.408 10.7783 24.0752 10.7783C24.8846 10.7783 25.3385 11.1394 25.3385 11.804V12.254L23.6869 12.3482C22.1502 12.4372 21.319 13.039 21.319 14.0856C21.319 15.1427 22.1776 15.844 23.408 15.844ZM23.7635 14.8758C23.058 14.8758 22.6096 14.5514 22.6096 14.0542C22.6096 13.5414 23.0416 13.2431 23.8674 13.196L25.3385 13.107V13.5676C25.3385 14.3316 24.6604 14.8758 23.7635 14.8758ZM28.2479 18C29.5385 18 30.1455 17.529 30.676 16.1004L33.0002 9.86251H31.6549L30.0963 14.6822H30.069L28.5104 9.86251H27.1268L29.369 15.8021L29.2486 16.1632C29.0463 16.7755 28.7182 17.0109 28.133 17.0109C28.0291 17.0109 27.8268 17.0005 27.7447 16.99V17.9686C27.8213 17.9895 28.1494 18 28.2479 18Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6206_121272">
          <rect width="38" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_6206_121272">
          <rect
            width="28"
            height="11"
            fill="white"
            transform="translate(5 7)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ApplePay
